//@flow
import Model from '../../Utils/Model/model';

export type AddressFields = {
  city:string,
  country_id:string,
  firstname:?string,
  lastname:?string,
  postcode:string,
  region:string,
  street:string[],
  telephone:string,
};

export type AddressObject = AddressFields&{
  id:string,
  is_commercial:boolean,
  is_default_shipping:boolean,
};

export default class AddressesModel extends Model<AddressObject> {

  getId():string {
    return this.attributes.id || '';
  }

  getFirstName():string {
    return this.attributes.firstname || '';
  }

  getLastName():string {
    return this.attributes.lastname || '';
  }

  getStreet():string[] {
    return this.attributes.street || ['', ''];
  }

  getFullName():string {
    const firstName = this.getFirstName();
    const lastName = this.getLastName();
    return `${firstName} ${lastName}`;
  }

  getCityStateZip():string {
    const city = this.getCity();
    const state = this.getRegion();
    const zip = this.getZip();
    if (!city || !state || !zip) return '';
    return `${city}, ${state} ${zip}`;
  }

  getFullStreet():string {
    const street = this.getStreet();
    if (!street[0]) return '';
    if (!street[1]) return street[0];
    return `${street[0]}, ${street[1]}`;
  }

  getCity():string {
    return this.attributes.city || '';
  }

  getRegion():string {
    return this.attributes.region || '';
  }

  getCountryId():string {
    return this.attributes.country_id || '';
  }

  getZip():string {
    return this.attributes.postcode || '';
  }

  getTelephone():string {
    return this.attributes.telephone || '';
  }

  getIsDefaultShipping():boolean {
    return this.attributes.is_default_shipping || false;
  }

  getIsCommercial():boolean {
    return this.attributes.is_commercial || false;
  }

  getIsPOBox():boolean {
    const poBoxMatcher =  /^ *((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[-. /\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i;
    const streets = this.getStreet();
    let isPoBox = false;
    streets.forEach(street => {
      if (poBoxMatcher.test(street)) isPoBox = true;
    });
    return isPoBox;
  }

}
